import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

export function withRouter(Component) {
  const WithRouter = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const history = React.useMemo(
      () => ({
        location,
        push: (to, state) => navigate(to, { state }),
        replace: (to, state) => navigate(to, { state, replace: true }),
        go: (delta) => navigate(delta),
        goBack: () => navigate(-1),
        goForward: () => navigate(1),
      }),
      [navigate, location],
    );

    return (
      <Component
        {...props}
        history={history}
        location={location}
        navigate={navigate}
        params={params}
      />
    );
  };

  WithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;

  return WithRouter;
}
